import React from 'react';

export const barackObama = {
  presidentNumber: 44,
  president: 'Barack Obama',
  subheader: 'Hope and Change',
  years: '2009-2017',
  predecessor: 'George W. Bush',
  successor: 'Donald Trump',
  disclaimer: {
    text: 'This document is the verified original.',
    link: 'https://ballotpedia.org/Letters_left_by_U.S._presidents_to_their_successors'
  },
  letter: {
    header: 'Letter to Donald Trump',
    content: `Dear Mr. President -

Congratulations on a remarkable run. Millions have placed their hopes in you, and all of us, regardless of party, should hope for expanded prosperity and security during your tenure.

This is a unique office, without a clear blueprint for success, so I don’t know that any advice from me will be particularly helpful. Still, let me offer a few reflections from the past 8 years.

First, we’ve both been blessed, in different ways, with great good fortune. Not everyone is so lucky. It’s up to us to do everything we can (to) build more ladders of success for every child and family that’s willing to work hard.

Second, American leadership in this world really is indispensable. It’s up to us, through action and example, to sustain the international order that’s expanded steadily since the end of the Cold War, and upon which our own wealth and safety depend.

Third, we are just temporary occupants of this office. That makes us guardians of those democratic institutions and traditions — like rule of law, separation of powers, equal protection and civil liberties — that our forebears fought and bled for. Regardless of the push and pull of daily politics, it’s up to us to leave those instruments of our democracy at least as strong as we found them.

And finally, take time, in the rush of events and responsibilities, for friends and family. They’ll get you through the inevitable rough patches.

Michelle and I wish you and Melania the very best as you embark on this great adventure, and know that we stand ready to help in any ways which we can.

Good luck and Godspeed,
BO`
  },
  biographical: [
    'Born August 4, 1961, in Honolulu, Hawaii',
    'Served two terms, January 20, 2009 – January 20, 2017',
    'First African American president in U.S. history',
    'Previously served as U.S. Senator from Illinois (2005-2009)',
    'Graduated from Harvard Law School'
  ],
  presidencyFacts: [
    'Signed the Affordable Care Act (Obamacare) into law',
    'Led response to the Great Recession',
    'Ordered the mission that killed Osama bin Laden',
    'Normalized relations with Cuba',
    'Signed the Paris Climate Agreement'
  ],
  milestones: [
    'Affordable Care Act passed (2010)',
    'Osama bin Laden killed in Pakistan (2011)',
    'Supreme Court legalized same-sex marriage (2015)',
    'Paris Climate Agreement signed (2015)',
    'Cuba relations normalized (2015)'
  ],
  personalLife: [
    'Married Michelle Robinson in 1992',
    'Has two daughters, Malia and Sasha',
    'First family to live in White House with young children',
    'Retired to Washington, D.C. after presidency',
    'Continues to be politically active'
  ],
  impactAndLegacy: [
    'First African American president',
    'Expanded healthcare coverage to millions',
    'Led economic recovery from Great Recession',
    'Advanced LGBTQ+ rights and marriage equality',
    'Restored America\'s international standing'
  ],
  postPresidency: [
    'Remained in Washington, D.C. after leaving office',
    'Founded the Obama Foundation',
    'Published memoir "A Promised Land" (2020)',
    'Continues to advocate for democracy and voting rights',
    'Remains influential in Democratic Party'
  ],
  historicalAnalysis: `Barack Obama's presidency navigated the Great Recession, achieved significant domestic reforms including healthcare expansion, and emphasized multilateral diplomacy while confronting increasing political polarization and congressional gridlock.

[SECTION] Financial Crisis Response and Economic Recovery

Obama inherited the worst economic crisis since the Great Depression, with unemployment rising toward 10% and major financial institutions facing collapse. The American Recovery and Reinvestment Act (2009) provided $787 billion in stimulus spending for infrastructure, education, and renewable energy while preventing deeper recession.

The Dodd-Frank Wall Street Reform Act (2010) strengthened financial regulation through the Volcker Rule, Consumer Financial Protection Bureau, and systemic risk oversight. The automotive industry bailout saved General Motors and Chrysler while preserving millions of manufacturing jobs, though it required controversial government intervention in private markets.

[SECTION] The Affordable Care Act and Healthcare Reform

The Patient Protection and Affordable Care Act (2010) represented the most significant domestic policy achievement since the Great Society, expanding health insurance coverage to over 20 million Americans. The law's individual mandate, insurance exchanges, and Medicaid expansion faced intense Republican opposition and legal challenges that reached the Supreme Court.

The botched rollout of HealthCare.gov damaged Obama's credibility while implementation challenges highlighted the complexity of healthcare reform. Despite problems, the ACA reduced the uninsured rate significantly while providing consumer protections and preventive care coverage.

[SECTION] Climate Change and Environmental Policy

Obama made climate change a central priority, using executive authority when congressional action proved impossible due to Republican opposition. The Clean Power Plan regulated carbon emissions from power plants while fuel efficiency standards for automobiles reduced greenhouse gas emissions.

The Paris Climate Agreement (2015) established international frameworks for addressing climate change through voluntary national commitments. However, the failure to pass comprehensive climate legislation during Democratic congressional control represented a significant missed opportunity.

[SECTION] Foreign Policy and Multilateral Diplomacy

Obama's foreign policy emphasized multilateral cooperation, diplomatic engagement, and reduced reliance on military intervention after the Bush era's costly wars. The Iran Nuclear Deal (2015) prevented Iranian nuclear weapons development through sanctions relief and international monitoring, though critics questioned its long-term effectiveness.

The "pivot to Asia" attempted to rebalance American strategic attention toward China's growing power while maintaining alliance relationships. The intervention in Libya (2011) helped remove Muammar Gaddafi but contributed to regional instability that Obama later called his "worst mistake."

[SECTION] Race Relations and Social Justice

Obama's presidency raised expectations for improved race relations while revealing persistent divisions highlighted by police shootings and social movements. The Black Lives Matter movement emerged during Obama's presidency, challenging police practices while creating political tensions about law enforcement and racial justice.

Obama's measured responses to racial incidents reflected his position as the first African American president and his desire to represent all Americans. Marriage equality advanced significantly during Obama's presidency, with his evolution on same-sex marriage rights culminating in Supreme Court recognition of marriage equality.

[SECTION] Congressional Relations and Political Gridlock

The Tea Party movement and Republican gains in the 2010 midterm elections created unprecedented congressional opposition that limited Obama's legislative achievements. The debt ceiling crisis (2011) and government shutdown (2013) demonstrated how political polarization could threaten basic governmental functions.

Obama's extensive use of executive orders and administrative actions reflected frustration with congressional gridlock while creating precedents for unilateral presidential action.

[SECTION] Technology and Social Media

Obama's campaigns pioneered the use of social media and data analytics for political mobilization, creating new models for democratic participation. However, the same technologies that enabled his electoral success also facilitated the spread of misinformation and political polarization that would challenge democracy.

The administration's response to Russian interference in the 2016 election raised questions about executive authority and partisan considerations in protecting electoral integrity.

[SECTION] Terrorism and National Security

Obama's counterterrorism strategy emphasized drone strikes and special operations while reducing large-scale military deployments. The killing of Osama bin Laden (2011) represented a significant achievement that demonstrated American capabilities and resolve.

The rise of ISIS required renewed military intervention in Iraq and Syria while highlighting the limitations of military solutions to political problems.

[SECTION] Economic Inequality and Social Change

Despite economic recovery, income inequality continued to grow during Obama's presidency, creating political pressures for more aggressive redistribution. The minimum wage remained unchanged at the federal level while some states and cities implemented significant increases.

Student loan debt reached crisis levels while college affordability became a major political issue affecting millennial voters.

[SECTION] Judicial Appointments and Legal Legacy

Obama's Supreme Court appointments—Sonia Sotomayor and Elena Kagan—increased court diversity while maintaining liberal positions on constitutional issues. The Republican Senate's refusal to consider Merrick Garland's nomination (2016) represented unprecedented partisan obstruction that would influence future confirmation battles.

[SECTION] 2016 Election and Democratic Transition

Obama's high approval ratings could not prevent Hillary Clinton's electoral defeat, raising questions about the transferability of personal popularity. Russian interference in the 2016 election created dilemmas about public disclosure and appropriate governmental response during an ongoing campaign.

Obama's gracious transition to Trump, despite policy disagreements, maintained democratic norms while preparing for potential constitutional challenges.

[SECTION] Historical Assessment

Early historical evaluation of Obama has been generally positive, with scholars praising his crisis management, policy achievements, and personal conduct in office. The ACA's survival and economic recovery's durability have strengthened Obama's reputation while his foreign policy legacy remains more mixed.

Modern presidential rankings typically place Obama in the upper tier, recognizing his significant domestic achievements while acknowledging the persistence of underlying political and social divisions. The Obama presidency demonstrates both the potential for presidential leadership during crises and the limitations of executive power in addressing structural social and economic problems.`,
  sources: [
    '[LINK:https://millercenter.org/president/obama/impact-and-legacy|Miller Center, University of Virginia. "Barack Obama: Impact and Legacy." Accessed 2025.]',
    '[LINK:https://www.history.com/topics/us-presidents/barack-obama|History.com. "Barack Obama: Facts, Presidency & Quotes." Updated February 2025.]',
    '[LINK:https://www.whitehousehistory.org/bios/barack-obama|White House Historical Association. "Barack Obama." Accessed 2025.]',
    '[LINK:https://en.wikipedia.org/wiki/Presidency_of_Barack_Obama|Wikipedia. "Presidency of Barack Obama." Updated 2025.]',
    '[LINK:https://www.penguinrandomhouse.com/books/30002/the-bridge-by-david-remnick/|Remnick, David. The Bridge: The Life and Rise of Barack Obama. Knopf, 2010.]',
    '[LINK:https://www.hachettebookgroup.com/titles/dan-pfeiffer/yes-we-still-can/9781455588206/|Pfeiffer, Dan. Yes We (Still) Can: Politics in the Age of Obama, Twitter, and Trump. Twelve, 2018.]',
    '[LINK:https://www.penguinrandomhouse.com/books/30003/the-world-as-it-is-by-ben-rhodes/|Rhodes, Ben. The World as It Is: A Memoir of the Obama White House. Random House, 2018.]'
  ]
};

export default barackObama;